import routeConfig from "@config/routes";
import { BarchartPage } from "@pages/BarchartPage";
import { ContactNetworkPage } from "@pages/ContactNetworkPage";
import { DataPage } from "@pages/DataPage";
import { GDPRPage } from "@pages/GDPRPage";
import { GridListPage } from "@pages/GridListPage";
import { ImprintPage } from "@pages/ImprintPage";
import { NotFoundPage } from "@pages/NotFoundPage";
import { PiechartPage } from "@pages/PiechartPage";
import { SparklinePage } from "@pages/SparklinePage";
import { SunburstPage } from "@pages/SunburstPage";
import { TimelinePage } from "@pages/TimelinePage";
import { TreemapPage } from "@pages/TreemapPage";
import { WranglerPage } from "@pages/WranglerPage";
import { SankeyPage } from "@pages/SankeyPage";
import ExportView from "containers/Components/ExportView";
import { Route, Routes } from "react-router-dom";

function AppRouter() {
  return (
    <Routes>
      {/* File and Data Parsing */}
      <Route path={routeConfig.App.Root} element={<DataPage />} />
      <Route path={routeConfig.App.Wrangler} element={<WranglerPage />} />
      <Route path={routeConfig.App.Data} element={<DataPage />} />
      {/* Classic Visualizations */}
      <Route path={routeConfig.App.Barchart} element={<BarchartPage />} />
      <Route path={routeConfig.App.Timeline} element={<TimelinePage />} />
      <Route path={routeConfig.App.Treemap} element={<TreemapPage />} />
      <Route path={routeConfig.App.List} element={<GridListPage />} />

      {/* Mental Model Paper */}
      <Route path={routeConfig.App.Sparklines} element={<SparklinePage />} />
      <Route path={routeConfig.App.Sunburst} element={<SunburstPage />} />
      <Route path={routeConfig.App.Piechart} element={<PiechartPage />} />

      {/* Student Visualizations */}
      <Route path={routeConfig.App.ContactGraph} element={<ContactNetworkPage />} />
      <Route path={routeConfig.App.Sankey} element={<SankeyPage />} />
      {/* Data Export */}
      <Route path={routeConfig.App.Export} element={<ExportView />} />
      {/* Imprint and Privacy Policy */}
      <Route path={routeConfig.App.AppImprint} element={<ImprintPage />} />
      <Route path={routeConfig.App.AppDsgvo} element={<GDPRPage />} />
      {/* <Route
        path={routeConfig.App.LocationHistory}
        element={<LocationHistoryPage />}
      /> */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export { AppRouter };
